import React from 'react';
import type { ValueFormat } from 'shared/src/api/ai-viz-types';

export type { CubeRow } from 'shared/src/utils/ai/ai-viz-transformers';

export const CHART_PALETTE = ['#2563eb', '#7c3aed', '#059669', '#d97706', '#dc2626', '#0891b2'];

export const TOOLTIP_STYLE: React.CSSProperties = {
  borderRadius: 12,
  border: '1px solid rgba(0,0,0,0.08)',
  boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  background: '#fff',
  padding: '10px 14px'
};

// Cached Intl.NumberFormat instances — construction is ~10x slower than .format()
const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
});
const numberFmt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
const integerFmt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function formatValue(v: number, fmt: ValueFormat): string {
  switch (fmt) {
    case 'currency':
      return currencyFmt.format(v);
    case 'percent':
      return `${v.toFixed(1)}%`;
    case 'number':
      return numberFmt.format(v);
    case 'integer':
      return integerFmt.format(Math.round(v));
    case 'date':
    case 'string':
    case 'enum':
      return String(v);
  }
}
